<template>
    <div id="receive-address">
        <div id="receive-address-header">
            <span class="title">我的收货地址</span>
        </div>

        <p v-if="addressList.length <= 0">暂无收货地址信息，请添加新的地址</p>

        <div id="receive-address-item" v-for="(item, index) in addressList" :key="index">
            <div class="profile-data">
                <span class="username">
                    {{item.username}}
                </span>

                <span class="number">
                    {{item.userPhone}}
                </span>
            </div>

            <div class="address">
                {{item.userAddress}}
            </div>

            <div class="receive-operation">
                <div class="operation-default" @click="editDefaultAddress(item.id)">
                    <span class="chooseIcon" :class="defaultIndex===item.id?'active':''"></span>
                    <label v-if="item.isDefault">默认地址</label>
                    <label v-else>设为默认</label>
                </div>

                <div class="delete">
                    <div style="float: left" @click="editAddress(item.id)">
                        <i class="icon"></i>
                        <span>编辑</span>
                    </div>
                    <span style="margin-left: 30px" @click="deleteAddress(item.id)">删除</span>
                </div>
            </div>

            <div class="clear"></div>
        </div>

        <div style="height: 100px; position: relative; background: #fdf9f7; "></div>

        <div id="add-address" @click="addNewAddress">
            添加新地址
        </div>

        <div class="back-btn" @click="backBtn">返回</div>

        <base-dialog v-show="messageVisible" :title="title" width="80%" display="none" @close="close">
            <p>{{ message }}</p>
            <div class="tip-cancel" @click="close">取消</div>
            <button class="tip-ok" @click="submitOrder" :disabled="btnDisable">确认</button>
        </base-dialog>

        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
    import {GetAddressList, DeleteAddress} from "../../api/Address";
    import {DefaultAddressUpdate} from "@/api/Address";
    import {starPhone} from "@/unitls";
    import BaseDialog from "@/components/BaseDialog";

    export default {
        name: "ReceiveAddress",
        components: {BaseDialog},
        data() {
            return {
                addressList: [],
                defaultIndex: 0, //默认选中第一个

                toastShow: false,
                toastText: '',

                title: '提示',
                messageVisible: false,
                message: "",

                deletedId: '',

                btnDisable: false,

            }
        },

        mounted() {
            this.getAddressList();

            //删除添加地址时存储的临时内容
            localStorage.setItem('consignee', '');
            localStorage.setItem('mobile', '');
            localStorage.setItem('distributionId', '');
            localStorage.setItem('area', '');
            localStorage.setItem('address', '');
            localStorage.setItem('lat', '');
            localStorage.setItem('lng', '');
        },

        methods: {
            close() {
                this.deletedId = '';
                this.messageVisible = false;
                this.$emit('close');
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false
                }, 1500)
            },

            addNewAddress() {
                this.$router.push({path: '/addressAdd'})
            },

            editAddress(id){
                this.$router.push({path: '/addressAdd', query:{id}});
            },

            getAddressList() {
                GetAddressList(0, -1).then(response => {
                    if (this.$API_CODE.OK === response.code) {
                        this.addressList = [];

                        response.data.list.forEach((item) => {
                            this.addressList.push({
                                id: item.id,
                                username: item.consignee,
                                userAddress: item.area + item.address,
                                userPhone: starPhone(item.mobile),
                                isDefault: item.default,
                            });
                            if (item.default) {
                                this.defaultIndex = item.id;

                            }
                        })
                    }
                })
            },
            deleteAddress(id) {
                this.deletedId = id;
                this.message = '是否要删除该地址？';
                this.messageVisible = true;
            },
            submitOrder() {
                this.messageVisible = false;
                this.btnDisable = true;
                DeleteAddress(this.deletedId)
                    .then((response) => {
                     if (response.code === this.$API_CODE.OK) {
                         this.toast('地址删除成功');
                         this.getAddressList();
                     }
                     this.btnDisable = false;
                })
            },

            editDefaultAddress(id) {
                DefaultAddressUpdate(id)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.toast('默认地址设置成功');
                            this.getAddressList();
                        }
                    })
            },

            backBtn() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped lang="scss">

    #receive-address {
        height: 100%;
        width: 100%;
        position: absolute;
        background: #fdf9f7;

        //header区域
        #receive-address-header {
            height: 6rem;
            line-height: 35px;
            background: url("../../assets/detail.png") no-repeat;
            background-size: 100% 6rem;
            width: 100%;

            .title {
                color: white;
                float: right;
                margin-right: 20px;
                line-height: 6rem;
                font-size: 1rem;
                font-weight: bold;
            }
        }

        #receive-address-item {
            margin-top: 10px;
            border-bottom: 1px solid #dddddd;
            border-top: 1px solid #dddddd;
            background: #FFFFFF;
            padding-left: 20px;
            padding-right: 20px;
            position: relative;

            .profile-data {
                margin-top: 20px;
                font-size: 0.9rem;

                .username {
                    float: left;
                }

                .number {
                    float: right;
                }
            }

            .address {
                clear: both;
                text-align: left;
                font-size: 0.9rem;
            }

            .receive-operation {
                margin-top: 5px;

                .operation-default {
                    float: left;
                    font-size: 0.9rem;

                    label {
                        padding: 5px;
                        float: left;
                    }
                }

                .delete {
                    float: right;
                    font-size: 0.9rem;
                    margin-top: 5px;

                    .icon {
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        margin-right: 5px;
                        background: url(../../assets/edit.png)no-repeat;
                        background-size: 100%;
                        float: left;
                    }
                }
            }

            .clear {
                clear: both;
                margin-bottom: 15px;
            }
        }

        .chooseIcon {
            width: 20px;
            height: 20px;
            display: inline-block;
            margin-top: 5px;
            background: url(../../assets/choose2.png)no-repeat;
            background-size: 100%;
            float: left;
        }

        .chooseIcon.active {
            width: 20px;
            height: 20px;
            margin-top: 5px;
            display: inline-block;
            background: url(../../assets/choose1.png)no-repeat;
            background-size: 100%;
            float: left;
        }

        #add-address {
            height: 3rem;
            background: #ea2d53;
            right: 0;
            bottom: 0;
            left: 0;
            width: 50%;
            position: fixed;
            z-index: 1;
            color: #FFFFFF;
            font-size: 1rem;
            line-height: 3rem;
        }

        .back-btn {
            position: fixed;
            z-index: 1;
            right: 0;
            bottom: 0;
            background: #fdf9f7;
            margin: auto;
            width: 50%;
            font-size: 1rem;
            font-weight: bold;
            color: #ea2d53;
            border: 1px solid #ea2d53;
            height: 3rem;
            line-height: 3rem;
        }

        .tip-cancel {
            float: left;
            width: 45%;
            color: #ffffff;
            padding: 10px 0;
            background: #ea2d53;
            border-radius: 5px;
        }

        .tip-ok {
            width: 45%;
            float: right;
            color: #ffffff;
            padding: 10px 0;
            background: #ea2d53;
            border-radius: 5px;
            border: none;
        }
    }
</style>